import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';
import { ContentRoute } from '@/_metronic/layout';
import { useCheckSuperAdminToken } from '../hooks/superAdminHooks';
import AiPromptQuestionEdit from './management/ai-setting/AiPromptEdit';
// import SuperAdminLayout from '@/_metronic/layout/components/SuperAdminLayout';

const SuperAdminLayout = lazy(() => import('@/_metronic/layout/components/SuperAdminLayout'));
const AnnouncementsPage = lazy(() => import('@/app/modules/Auth/pages/management/announcement/AnnouncementsPage'));
const AnnouncementEdit = lazy(() =>
  import('@/app/modules/Auth/pages/management/announcement/announcement-edit-dialog/AnnouncementEdit')
);
const AnnouncementPopupNotifyEdit = lazy(() =>
  import('@/app/modules/Auth/pages/management/announcement/announcement-popup-notify/AnnouncementPopupNotifyEdit')
);
const FeaturePackageEditPage = lazy(() =>
  import('@/app/modules/Auth/pages/management/featurePackage/FeaturePackageEdit')
);
const MiniPosFeaturePackageEditPage = lazy(() =>
  import('@/app/modules/Auth/pages/management/FeaturePackageMiniPos/EditPage')
);
const OpenApiUserEdit = lazy(() => import('@/app/modules/Auth/pages/management/openapi/OpenApiUserEdit'));
const OpenapiTokenCreate = lazy(() => import('@/app/modules/Auth/pages/management/openapi/OpenApiTokenCreate'));
const InternalApiClientEditPage = lazy(() =>
  import('@/app/modules/Auth/pages/management/internalApiClients/InternalApiClientEditPage')
);
const SystemRoleEditPage = lazy(() =>
  import('@/app/modules/Auth/pages/management/systemRoles/SystemRoleEditPage')
);
const Management = lazy(() => import('@/app/modules/Auth/pages/management'));
const AiPackageEditPage = lazy(() => import('@/app/modules/Auth/pages/management/ai-setting/AiPackageEditPage'));
const ManagementLogin = lazy(() => import('@/app/modules/Auth/pages/ManagementLogin'));

function SuperAdminAuthPage() {
  useCheckSuperAdminToken();
  return (
    <SuperAdminLayout>
      <Switch>
        <ContentRoute exact path="/shop/management/login" component={ManagementLogin} />
        <ContentRoute exact path="/shop/management" component={Management} />
        <ContentRoute exact path="/shop/management/announcement" component={AnnouncementsPage} />
        <ContentRoute exact path="/shop/management/announcement/new" component={AnnouncementEdit} />
        <ContentRoute exact path="/shop/management/announcement/:editType" component={AnnouncementPopupNotifyEdit} />
        <ContentRoute exact path="/shop/management/announcement/:editType" component={AnnouncementPopupNotifyEdit} />
        <ContentRoute
          exact
          path="/shop/management/announcement/:announcementId/edit/:editType"
          component={AnnouncementPopupNotifyEdit}
        />
        <ContentRoute
          exact
          path="/shop/management/announcement/:announcementId/edit/:editType"
          component={AnnouncementPopupNotifyEdit}
        />
        <ContentRoute exact path="/shop/management/announcement/:announcementId/edit" component={AnnouncementEdit} />
        <ContentRoute exact path="/shop/management/announcement/:announcementId/delete" component={AnnouncementsPage} />
        <ContentRoute exact path="/shop/management/feature-package/new" component={FeaturePackageEditPage} />
        <ContentRoute path="/shop/management/feature-package/:featurePackageId" component={FeaturePackageEditPage} />

        <ContentRoute exact path="/shop/management/mini-pos-feature-package/new" component={MiniPosFeaturePackageEditPage} />
        <ContentRoute path="/shop/management/mini-pos-feature-package/:id" component={MiniPosFeaturePackageEditPage} />

        <ContentRoute exact path="/shop/management/openapi/user/create" component={OpenApiUserEdit} />
        <ContentRoute exact path="/shop/management/openapi/token/new" component={OpenapiTokenCreate} />
        <ContentRoute exact path="/shop/management/openapi/user/:openapiUserId" component={OpenApiUserEdit} />
        <ContentRoute
          exact
          path="/shop/management/internal-api-clients/new"
          component={InternalApiClientEditPage}
        />
        <ContentRoute
          exact
          path="/shop/management/internal-api-clients/:clientId"
          component={InternalApiClientEditPage}
        />
        <ContentRoute exact path="/shop/management/system-roles/new" component={SystemRoleEditPage} />
        <ContentRoute exact path="/shop/management/system-roles/:roleId" component={SystemRoleEditPage} />
        <ContentRoute exact path="/shop/management/prompt-question/new" component={AiPromptQuestionEdit} />
        <ContentRoute exact path="/shop/management/prompt-question/:questionId/edit" component={AiPromptQuestionEdit} />
        <ContentRoute exact path="/shop/management/ai-package/new" component={AiPackageEditPage} />
        <ContentRoute path="/shop/management/ai-package/:id" component={AiPackageEditPage} />
      </Switch>
    </SuperAdminLayout>
  );
}

export default SuperAdminAuthPage;
